import HallServerNotify from "../hall/server/hallnotify/hall_serve_notify";
import GameServer from "../hall/server/gameserver/game_server";

// Learn TypeScript:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/typescript.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/reference/attributes.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/life-cycle-callbacks.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/life-cycle-callbacks.html

const {ccclass, property} = cc._decorator;

@ccclass
export default class PingComponent extends cc.Component {

    @property
    isHallUse:boolean = true

    @property(cc.SpriteFrame)
    wifiSprites:cc.SpriteFrame[] = []

    @property(cc.Sprite)
    wifiIcon :cc.Sprite = null

    @property(cc.Label)
    pingTex : cc.Label = null

    pingColor = [new cc.Color(255, 0, 0, 255), new cc.Color(255, 255, 0, 255), new cc.Color(195, 184, 0, 255), new cc.Color(123, 185, 59, 255), new cc.Color(43, 237, 80, 255)]
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        if(this.isHallUse){
            HallServerNotify.instance.onNotifyPing = (ping: number) => {
                this.showPing(ping)
            }
        }else{
            GameServer.instance.onNotifyPing = (ping:number)=>{
                this.showPing(ping);
            }
        }       
    }

    // update (dt) {}

    showPing(ping){
       
        let idx = 0
        if(ping >= 901){
            idx = 0
        }else if(ping >= 501){
            idx = 1
        }else if(ping >= 301){
            idx = 2
        }else if(ping >= 151){
            idx = 3
        }else{
            idx = 4
        }
        
        this.wifiIcon.spriteFrame = this.wifiSprites[idx]
        this.pingTex.string = "延迟" + ping + "ms"
        this.pingTex.node.color = this.pingColor[idx]
    }

    onDestroy() {
        if(this.isHallUse){
            HallServerNotify.instance.onNotifyPing = null
        }else{
            GameServer.instance.onNotifyPing = null
        }
    }
}
